import React from 'react';
import { Button, Select, Divider } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useSimpleCondition from './useSimpleCondition';

import DeviceDisconnectionInputValues from './components/DeviceDisconnectionInputValues';
import MissingInputValues from './components/MissingInputValues';
import ThresholdInputValue from './components/ThresholdInputValue';

import styles from './SimpleCondition.module.less';

const { Option } = Select;

function SimpleCondition(props) {

  const { t } = useTranslation();
  const { isLastItem, ...rest } = props;
  const {
    orCondition,
    removeOrCondition,
    onChangeOrCondition,
    alarmsFieldsLoading,
    filterFields,
    fieldSelected,
    isEditDefault,
    typeAlarm,
    deviceType,
  } = useSimpleCondition({ ...rest });
  const { type, params } = orCondition;

    //console.log('type: ', type);
    //console.log('typeAlarm: ', typeAlarm);    
    //console.log('filterFields: ', filterFields);

  return (
    <>
      <div className={styles.wrapper}>
        <Button
          className={styles.remove_item}
          shape="circle"
          size="small"
          type="text"
          onClick={removeOrCondition}
          disabled={isEditDefault}
        >
          <FontAwesomeIcon icon={faMinusCircle} />
        </Button>

        <div className={styles.inputs}>
          <Select
            className={`${styles.take_two_columns}`}
            value={type}
            onSelect={(value) => onChangeOrCondition('type', value)}
            disabled={isEditDefault}
          >
            {['Device-Disconnection'].includes(typeAlarm) && (
              <Option value="device_disconnection">
                {t('views.dynamic_alarms_create_edit.rule_type_options.Device_disconnection')}
              </Option>
            )}
            {['Missing'].includes(typeAlarm) && (
              <Option value="missing_data">
                {t('views.dynamic_alarms_create_edit.rule_type_options.missing_data')}
              </Option>
            )}
            {['Inst-Telemetry-Battery', 'Inst-Telemetry-Consumption', 'Inst-Telemetry-Grid', 'Inst-Telemetry-Solar', 'Inst-Telemetry-Other']
              .includes(typeAlarm) && (
                <>
                  <Option value="numeric_threshold">
                  {t('views.dynamic_alarms_create_edit.type_alarm_options.numeric_threshold')}
                  </Option>
                  <Option value="time_threshold">
                    {t('views.dynamic_alarms_create_edit.type_alarm_options.time_threshold')}
                  </Option>
                </>
            )}
          </Select>

          {(['numeric_threshold','time_threshold', 'equality'].includes(type)
            || ['Device-Disconnection', 'Missing'].includes(typeAlarm)) && (
              <>
               {
                deviceType && type === 'numeric_threshold' &&(
                    <Select
                      loading={alarmsFieldsLoading}
                      className={`${styles.take_two_columns}`}
                      value={params.field}
                      onSelect={(value) => onChangeOrCondition('field', value)}
                      disabled={isEditDefault}
                    >
                      {filterFields.map((field, index) => {

                        const { name, edge_name } = field;
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          <Option key={`edge_name_${index}`} value={edge_name}>
                            {name}
                          </Option>
                        );

                      })}
                    </Select>
                )
               }

              {
                type === 'time_threshold' &&(
                    <Select 
                      className={`${styles.take_two_columns}`}
                      value={params.field}
                      onSelect={(value) => onChangeOrCondition('field', value)}
                      disabled={isEditDefault}
                    >
                       
                       <Option key={`time`} value={'TIME'}>
                            {t('views.dynamic_alarms_create_edit.type_alarm_options.time')}
                        </Option>
                      
                    </Select>
                )
               }
                

                {(type === 'numeric_threshold' || type === 'time_threshold')  && (
                  <ThresholdInputValue
                    params={params}
                    orCondition={orCondition}
                    onChangeOrCondition={onChangeOrCondition} 
                  />
                )}

                {type === 'missing_data' && (
                  <MissingInputValues
                    params={params}
                    onChangeOrCondition={onChangeOrCondition} 
                  />
                  
                )}

                {type === 'device_disconnection' && (
                   <DeviceDisconnectionInputValues
                   params={params}
                   onChangeOrCondition={onChangeOrCondition} 
                 />
                )}

              </>
          )}

        </div>
      </div>
      {!isLastItem && <Divider className={styles.divider} />}
    </>
  );

}

SimpleCondition.propTypes = {
  groupIndex: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  isLastItem: PropTypes.bool,
};

SimpleCondition.defaultProps = {
  isLastItem: false,
};

export default SimpleCondition;
